/* eslint-disable @typescript-eslint/no-explicit-any */
import { Navigate } from "react-router-dom";
import cookieUtil from "@/utils/cookieUtils";
import loginEnum from "@/app/csr-src/data/consts/login";
export const ProtectedRoute = ({ children }: any) => {
  const mfs_session = cookieUtil.getCookie(loginEnum.CookiesEnum.MFS_SESSION);
  const _href = window.location.href;
  if (!mfs_session) {
    return <Navigate to={"/login?returnUrl=" + _href} />;
  }
  return children;
};

export default ProtectedRoute;
